import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { saveHomework } from '@common/api/homeworks';

import Grade from '../GradeBooks/Grade';
import Media from '../Media';

const Homework = types
	.model('Homework', {
		id: types.identifierNumber,
		description: types.maybeNull(types.string),
		file_urls: types.maybeNull(types.array(types.string)),
		files: types.maybeNull(types.array(Media)),
		should_be_completed: types.optional(types.boolean, false),
		grade: types.maybeNull(Grade),
		status: types.maybeNull(types.optional(types.number, 0)),
	})
	.volatile(() => ({
		loading: false,
	}))

	.actions((self) => ({
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield saveHomework(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export interface IHomeworkModel extends Instance<typeof Homework> {}

export default Homework;
